// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2a15bc67","703":"f7da2245"}[chunkId] + ".chunk.js";
};